<template>
    <DFormRow
        v-show="option.visible"
        :label="option.translated_name"
        :is-required="option.required"
        :error="error"
        :hint="option.description"
    >
        <DSwitch
            v-if="option.type === 'bool'"
            :id="`contract-option-${option.name}`"
            v-model="value"
            color="success"
            variant="3d"
            :disabled="contract.id && isNotEditable(option.editable)"
            :class="{'is-invalid': !!error}"
            @update:checked="$emit('update', $event)"
        />
        <DInput
            v-if="['string', 'integer', 'email', 'numeric'].includes(option.type)"
            :id="`contract-option-${option.name}`"
            v-model="value"
            :disabled="contract.id && isNotEditable(option.editable)"
            :is-valid="isValid"
            @update:value="$emit('update', $event)"
        />
        <DFormTextarea
            v-if="option.type === 'text' || option.type === 'array'"
            :id="`contract-option-${option.name}`"
            v-model="value"
            :disabled="contract.id && isNotEditable(option.editable)"
            :is-valid="isValid"
            rows="8"
            @update:modelValue="$emit('update', $event)"
        />
        <DSelect
            v-if="option.type === 'list'"
            :id="`contract-option-${option.name}`"
            v-model="isCountry"
            :options="option.options"
            :disabled="contract.id && isNotEditable(option.editable)"
            :is-valid="isValid"
            :placeholder="option.description"
            @update:value="$emit('update', $event)"
        />
        <DMultiSelect
            v-if="option.type === 'multiselect'"
            :id="`contract-option-${option.name}`"
            v-model="value"
            :search="true"
            :selection="true"
            :options="option.options"
            :disabled="contract.id && isNotEditable(option.editable)"
            :is-valid="isValid"
            @update="$emit('update', $event)"
        />
        <DMultiSelect
            v-if="option.type === 'search_list'"
            :id="`contract-option-${option.name}`"
            v-model="value"
            :search="true"
            :selection="false"
            :multiple="false"
            :options="option.options"
            :disabled="contract.id && isNotEditable(option.editable)"
            :is-valid="isValid"
            @update="$emit('update', $event)"
        />
        <DContractOptionModal
            v-if="option.type === 'modal'"
            :id="`contract-option-${option.name}`"
            :value="option.value"
            :display-value="displayValue"
            :disabled="contract.id && isNotEditable(option.editable)"
            :is-valid="isValid"
            :name="option.name"
            :fulfillment-module="fulfillmentModuleValue"
            @update:modelValue="$emit('update', $event)"
        />
    </DFormRow>
</template>

<script>
import DContractOptionModal from '~@/Components/Fulfillment/Options/DContractOptionModal'

export default {
    name: 'ConfigOptions',
    components: {
        DContractOptionModal
    },
    props: {
        contract: {
            type: Object,
            default: () => {
                return {}
            }
        },
        error: {
            type: String,
            default: null
        },
        option: {
            type: Object,
            default: () => {
                return {}
            }
        },
        fulfillmentModule: {
            type: String,
            default: null
        },
        isValid: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update'],
    data () {
        return {
            value: this.option.value
        }
    },
    computed: {
        displayValue () {
            return this.option.display_value === null ? this.option.value : this.option.display_value
        },
        fulfillmentModuleValue () {
            return this.fulfillmentModule !== null ? this.fulfillmentModule : this.contract?.fulfillment_module
        },
        isCountry () {
            return this.option.name === 'country' ? this.$page.props.defaultCountry : this.value
        }
    },
    methods: {
        isNotEditable (isEditable) {
            if (this.fulfillmentModuleValue === 'yext') {
                return ['active', 'wait_for_payment', 'wait_for_activation', 'wait_for_contract_start', 'done', 'suspended'].includes(this.contract?.status) && !isEditable
            }

            return !isEditable
        }
    }
}
</script>
